<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('@/assets/T_logo_rgb_p.svg')"
          class="my-3"
          contain
          height="50"
          style="filter: invert(0%);"
          v-if="tenant == 'GO' || tenant == 'TMCZ_GO'"
        />
        <v-img
          :src="require('@/assets/digi/digi_sk_logo.svg')"
          class="my-3"
          contain
          height="50"
          v-else-if="tenant == 'DIGI'"
        />
      </v-col>

      <v-col class="mb-4">
        <h1 class="font-weight-bold mb-3">
          Simulator (Login with parameters)
        </h1>

        </v-col>
    </v-row>

    <v-row>
        <v-col cols="12" sm="6">
            <v-text-field dense clearable outlined label="Client ID (noPKCE)" hide-details="auto" v-model="client_id_nopkce"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
            <v-text-field dense clearable outlined label="Client ID (PKCE)" hide-details="auto" v-model="client_id_pkce"></v-text-field>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" sm="6">
            <v-text-field dense clearable outlined label="Redirect URI (override only)" hide-details="trie" v-model="redirect_uri"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
            <v-select :items="tenantoptions" label="Tenant" outlined v-model="tenant" hide-details="true" dense></v-select>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" sm="6">
            <v-text-field dense clearable outlined label="User Code" hide-details="auto" v-model="user_code" append-icon="mdi-download" @click:append="getUserCode"></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
            <v-text-field dense clearable outlined label="Device Code" hide-details="auto" v-model="device_code" append-icon="mdi-download" @click:append="getUserCode"></v-text-field>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" sm="6">
            <v-text-field dense clearable outlined label="Code Verifier" hide-details="auto" v-model="codeVerifier" disabled></v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
            <v-text-field dense clearable outlined label="State" hide-details="auto" v-model="state" disabled></v-text-field>
        </v-col>
    </v-row>
          
    <br/>
    <v-text-field dense clearable outlined label="SHA256" hide-details="auto" v-model="sha256base64" disabled></v-text-field>
    <br/>
    <v-btn class="loginBtn white--text" :color="tenantColor" @click="deviceFlowRedirect" @mouseover="target_url = deviceFlowUrl">Device Flow Login</v-btn>
    <v-btn class="loginBtn white--text" :color="tenantColor" @click="authorizationFlowNoPkceRedirect" @mouseover="target_url = authorizationFlowNoPkceUrl">Auth Flow Login (noPKCE)</v-btn>
    <v-btn class="loginBtn white--text" :color="tenantColor" @click="authorizationFlowPkceRedirect" @mouseover="target_url = authorizationFlowPkceUrl">Auth Flow Login (PKCE)</v-btn>
    <br/><br/>
    <v-textarea dense clearable outlined rows="4" label="Target URL" hide-details="auto" v-model="target_url" disabled></v-textarea>

  </v-container>
</template>

<style>
.loginBtn {
    margin: 2px 2px 2px 2px;
}
</style>

<script>
  import { api } from "../main";
  import VueCookies from 'vue-cookies'
  import sha256 from 'js-sha256'

  export default {
    name: 'HomeComponent',

    data: () => ({
      'client_id_nopkce': '',
      'client_id_pkce': '',
      'flow': '',
      'redirect_uri': '',
      'voyo_uri': {
        "GO": {
          "nopkce": 'https://voyo.markiza.staging.sk/api/v1/partner/auth-code',
          "pkce": 'https://voyo.markiza.staging.sk/api/v1/partner/callback'
        },
        "DIGI": {
          "nopkce": 'https://voyo.markiza.staging.sk/api/v1/partner/auth-code',
          "pkce": 'https://voyo.markiza.staging.sk/api/v1/partner/callback'
        },
        "TMCZ_GO": {
          "nopkce": 'https://voyo.nova.staging.sk/api/v1/partner/auth-code',
          "pkce": 'https://voyo.nova.staging.sk/api/v1/partner/callback'
        }
      },
      'flowoptions': ['AUTHORIZATION_CODE', 'DEVICE_CODE'],
      'tenant': '',
      'tenantoptions': ['GO','DIGI','TMCZ_GO'],
      'user_code': '',
      'device_code': '',
      'target_url': 'https://'
    }),

    computed: {
        /*
        loginUrl() {
            return '/login?client_id=' + this.client_id_nopkce + '&flow=' + this.flow + '&redirect_uri=' + this.redirect_uri + '&tenant=' + this.tenant + '&user_code=' + this.user_code;
        },
        */
        url_device_flow() {
            return api.baseUrl[this.tenant] + '/oauth/authorize/device';
        },
        url_authorization_flow() {
            return api.baseUrl[this.tenant] + '/oauth/authorize';
        },
        codeVerifier() {
            return (Math.random() + 1).toString(36).substring(4);
        },
        state() {
            return (Math.random() + 1).toString(36).substring(4);
        },
        sha256base64() {
            return this.base64_urlencode(this.hex2a(sha256(this.codeVerifier)));
        },
        deviceFlowUrl() {
            return this.url_device_flow + '?user_code=' + this.user_code + '&state=' + this.state; // + '&client_id=' + this.client_id_nopkce + '&flow=DEVICE_CODE';
        },
        finalRedirectUrl() {
            if(typeof(this.redirect_uri) === 'undefined' || this.redirect_uri === null || this.redirect_uri === '')  {
                return this.voyo_uri[this.tenant];
            }
            else {
                return {"pkce": this.redirect_uri, "nopkce": this.redirect_uri};
            }
        },
        authorizationFlowNoPkceUrl() {
            return this.url_authorization_flow + '?scope=PARTNER_APP_LOGIN&client_id=' + this.client_id_nopkce + '&redirect_uri=' + this.finalRedirectUrl.nopkce + '&state=' + this.state;
        },
        authorizationFlowPkceUrl() {
            return this.url_authorization_flow + '?scope=PARTNER_APP_LOGIN&client_id=' + this.client_id_pkce + '&redirect_uri=' + this.finalRedirectUrl.pkce + '&code_challenge_method=S256&code_challenge=' + this.sha256base64 + '&state=' + this.state;
        },
        tenantColor() {
            return this.tenant == 'DIGI' ? '#0095DA' : '#EA0A8E';
        }
    },

    methods: {
        hex2a(hexx) {
            var hex = hexx.toString();//force conversion
            var str = '';
            for (var i = 0; i < hex.length; i += 2)
                str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
            return str;
        },
        base64_urlencode(str) {
            return btoa(str)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
        },
        deviceFlowRedirect() {
            VueCookies.set('client_id_nopkce', this.client_id_nopkce);
            VueCookies.set('client_id_pkce', this.client_id_pkce);
            window.location.href = this.deviceFlowUrl;
        },
        authorizationFlowNoPkceRedirect() {
            VueCookies.set('client_id_nopkce', this.client_id_nopkce);
            VueCookies.set('client_id_pkce', this.client_id_pkce);
            window.location.href = this.authorizationFlowNoPkceUrl;
        },
        authorizationFlowPkceRedirect() {
            VueCookies.set('client_id_nopkce', this.client_id_nopkce);
            VueCookies.set('client_id_pkce', this.client_id_pkce);
            window.location.href = this.authorizationFlowPkceUrl;
        },
        async getUserCode() {
            VueCookies.set('client_id_nopkce', this.client_id_nopkce);
            VueCookies.set('client_id_pkce', this.client_id_pkce);

            // PREPARE DATA
            var data = {
                "client_id": this.client_id_nopkce,
                "scope": 'PARTNER_APP_LOGIN',
                "language": VueCookies.get('language')
            };
            // HTTP REQUEST
            const options = {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              body: new URLSearchParams(data)
            };
            var res = await api.requestData(api.baseUrl[this.tenant] + '/oauth/device/code', options);

            // REQUEST RESULTS ACTIONS
            if(res.status == 'ok') {
                this.user_code = res.responseBody.user_code;
                this.device_code = res.responseBody.device_code;
            }
            else {
            if(res.responseStatus == 'ECONNRESET') {
                this.error = 'Pripojenie na server zlyhalo.';
            }
            else {
                this.error = res.responseBody.error_description;
                if (res.responseStatus == '401') { 
                    setTimeout(() => {this.$router.push({ path: VueCookies.get('loginPath') })}, 3000);
                }
            }              
            }
        }
    },

    watch: {
        // whenever question changes, this function will run
        tenant(newTenant) {
            this.$emit('updateTenant',newTenant);
        }
    },

    created: async function(){
        this.client_id_nopkce = VueCookies.get('client_id_nopkce') || '';
        this.client_id_pkce = VueCookies.get('client_id_pkce') || '';
        //this.redirect_uri = VueCookies.get('redirect_uri') || '';
        this.flow = VueCookies.get('flow') || 'AUTHORIZATION_CODE';
        this.tenant = VueCookies.get('tenant') || 'GO';
        this.user_code = VueCookies.get('user_code') || '';
        //console.log('parent', this.$parent.$attrs)
    }
  }
</script>
